/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import makeCancelable from 'lib/makeCancelable';
import getTestProps from 'test/lib/cypress/getTestProps';
import * as net from 'util/Net';

import {ExternalFlatFileDelimiter, parseRows} from './ExternalFileUtils';

interface Props {
  url: string;
  maxRows?: number;
  // The presence of file will cause url to be ignored.
  file?: Pick<File, 'text'>;
  /**
   * The delimiter of the file. If undefined, either TSV or CSV will be inferred based on the file's contents.
   */
  delimiter?: ExternalFlatFileDelimiter;
}

type State = any;

class CSVFilePreview extends React.Component<Props, State> {
  filePromise: any;
  override state: State = {
    isLoading: true,
    rows: null,
  };

  override componentDidMount(): void {
    if (this.props.file != null) {
      this.filePromise = makeCancelable(this.props.file.text());
    } else {
      this.filePromise = makeCancelable(Promise.resolve(net.get(this.props.url)));
    }
    this.filePromise.promise
      .then((data: any) => {
        const rows = parseRows(data, this.props.delimiter);
        this.setState({rows, isLoading: false});
      })
      .catch((response: any) => {
        if (response.isCanceled) {
          return;
        }
        this.setState({isLoading: false});
      });
  }

  override componentWillUnmount(): void {
    if (this.filePromise) {
      this.filePromise.cancel();
    }
  }

  override render(): JSX.Element {
    if (this.state.isLoading) {
      return <p className="u-spacing-top faded text-center">Loading...</p>;
    }
    if (!this.state.rows) {
      return (
        <p className="u-spacing-top faded text-center">
          An error occurred while loading the file. Please try again.
        </p>
      );
    }
    if (this.state.rows.length === 0) {
      return <p className="u-spacing-top faded text-center">The file is empty.</p>;
    }
    return (
      <div className="container">
        <table
          className="table table-striped selectable"
          {...getTestProps({component: 'CSVFilePreview', element: 'table'})}
        >
          <thead>
            <tr>
              {this.state.rows[0].map((value: any, colIndex: any) => (
                <th key={colIndex} {...getTestProps({component: 'CSVFilePreview', element: 'columnHeader'})}>
                  {value}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {this.state.rows
              .slice(1, this.props.maxRows ? this.props.maxRows + 1 : undefined)
              .map((cols: any, rowIndex: any) => (
                <tr key={rowIndex} {...getTestProps({component: 'CSVFilePreview', element: 'dataRow'})}>
                  {cols.map((value: any, colIndex: any) => (
                    <td key={colIndex}>{value}</td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default CSVFilePreview;
